import { AlertCircle, CloudOff, RefreshCw } from 'lucide-react'
import { cn } from '@/lib/cn'
import { describeQueryError } from './describe'
import styles from './QueryErrorNotice.module.scss'

export interface QueryErrorNoticeProps {
  error: unknown
  /** Refetch da query; sem ele, o botão "Tentar de novo" não aparece. */
  onRetry?: (() => void) | undefined
  /** O que falhou, com artigo: "os pools", "a correlação"… */
  label?: string
  /** Versão de uma linha, para docks e diálogos. */
  compact?: boolean
  className?: string
}

/**
 * Aviso discreto no lugar do conteúdo de uma seção cuja query falhou. O
 * resto da página (cabeçalho, filtros, ações) continua de pé. Para erro de
 * mutação (salvar, gerar…) use toast/linha com ``errorMessage``.
 */
export function QueryErrorNotice({ error, onRetry, label, compact = false, className }: QueryErrorNoticeProps) {
  const { message, detail, showRetry, requestId, offline } = describeQueryError(error, label)

  return (
    <div className={cn(styles.notice, compact && styles.compact, className)} role="status">
      <span className={styles.icon} aria-hidden>
        {offline ? <CloudOff /> : <AlertCircle />}
      </span>
      <div className={styles.text}>
        <p className={styles.message}>{message}</p>
        {detail ? <p className={styles.detail}>{detail}</p> : null}
        {requestId ? <span className={styles.requestId}>req: {requestId}</span> : null}
      </div>
      {onRetry && showRetry ? (
        <button type="button" className={styles.retry} onClick={onRetry}>
          <RefreshCw aria-hidden />
          Tentar de novo
        </button>
      ) : null}
    </div>
  )
}
